import styled from 'styled-components';

const Row = styled.div<{ height?: number }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: ${(p) => (p.height ? `${p.height}px` : 'auto')};
  overflow-y: visible;
`;

export default Row;
